{
  "all_of": "All of {name}’s",
  "also_on": "Also sees this: {names}",
  "empty_body": "When someone you follow adds you to one of their sharing lists, its things show up here.",
  "empty_find": "Find people to follow",
  "empty_heading": "Nothing shared with you yet",
  "everyone": "Everyone",
  "feed_empty_body": "When the people who share with you add things to a list you’re on, they show up here.",
  "feed_empty_heading": "Nothing on their lists yet",
  "filters_label": "Show",
  "from": "{name}’s list",
  "gift_bought": "Bought",
  "gift_by": "{name}’s gifting this",
  "gift_by_guest": "{name}’s gifting this, from the list’s link",
  "gift_by_someone": "Someone’s gifting this",
  "gift_cta": "I’m gifting this",
  "gift_cta_bought": "I’ve already bought it",
  "gift_failed": "Couldn’t save that. Try again?",
  "gift_gone": "This isn’t shared with you any more.",
  "gift_got": "{name} has this already.",
  "gift_keep": "Keep it",
  "gift_label": "Gifting",
  "gift_let_go": "Let it go",
  "gift_let_go_explain": "Someone else can gift it then.",
  "gift_mark_bought": "Mark bought",
  "gift_mine": "You’re gifting this",
  "gift_offline": "You’re offline. Try again once you’re connected.",
  "gift_strip_by": "{name}’s gifting",
  "gift_strip_guest": "{name}’s gifting (by link)",
  "gift_strip_mine": "You’re gifting",
  "gift_strip_taken": "Taken",
  "gift_surprise": "Keep it a surprise",
  "gift_surprise_off": "{name} will see someone’s gifting it — never who.",
  "gift_surprise_on": "{name} won’t see that it’s taken.",
  "gift_taken": "Someone else is gifting this now.",
  "gift_to_buy": "To buy",
  "gifting_empty_body": "Open something on Their Things and tap I’m gifting this. It shows up here, ready for shopping.",
  "gifting_empty_heading": "Nothing yet",
  "gifting_heading": "I’m gifting",
  "gifting_sub": "What you’ve said you’ll give, soonest first.",
  "got_badge": "{name} got this",
  "got_short": "Got it",
  "just_you": "Only you and {name} see this.",
  "leave": "Leave this list",
  "leave_confirm": "Leave",
  "leave_explain": "You’ll stop seeing {list}. {name} can add you to it again.",
  "leave_failed": "You’re still on that list. Try again?",
  "leave_keep": "Keep",
  "list_empty_body": "When {name} adds things to it, they show up here.",
  "list_empty_heading": "Nothing on {list} yet",
  "lists_label": "{name}’s lists",
  "load_failed": "Couldn’t load what’s shared with you.",
  "offline": "You’re offline. What’s shared with you shows once you’re connected.",
  "others_more": {
    "one": "{count} other",
    "other": "{count} others"
  },
  "page_description": "The things the people you follow share with you.",
  "page_title": "Their Things — TingThings",
  "people_label": "People who share with you",
  "person_empty_body": "When {name} adds things to a list you’re on, they show up here.",
  "person_empty_heading": "Nothing from {name} yet",
  "retry": "Try again",
  "sheet_close": "Close",
  "sheet_lists_label": "Lists it’s on",
  "sheet_on_list": "On {list}",
  "sheet_open_link": "Open the link",
  "strip_more": "+{count}",
  "who_sees_all": "See all {count}",
  "who_sees_hide": "Hide"
}
